import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface BrandingConfig {
  companyName: string;
  logoUrl?: string;
  primaryColor: string;
  secondaryColor: string;
  tenantId?: string;
  companyId?: string;
}

const DEFAULT_BRANDING: BrandingConfig = {
  companyName: 'Arlo Auto',
  logoUrl: undefined,
  primaryColor: '#1E3A5F',
  secondaryColor: '#F59E0B',
};

interface BrandingState {
  branding: BrandingConfig;
  setBranding: (branding: Partial<BrandingConfig>) => void;
  resetBranding: () => void;
}

export const useBrandingStore = create<BrandingState>()(
  devtools(
    (set) => ({
      branding: DEFAULT_BRANDING,

      setBranding: (partial) =>
        set((state) => ({ branding: { ...state.branding, ...partial } })),

      resetBranding: () => set({ branding: DEFAULT_BRANDING }),
    }),
    { name: 'branding-store' },
  ),
);
